import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { t } = useTranslation('common');

  const contactMethods = [
    {
      icon: 'ri-mail-line',
      title: t('contact.business.title'),
      content: t('contact.business.email'),
      description: t('contact.business.description'),
      action: '发送邮件',
      href: `mailto:${t('contact.business.email')}`,
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-customer-service-line',
      title: t('contact.support.title'),
      content: t('contact.support.description'),
      description: t('contact.support.desc'),
      action: t('contact.support.button'),
      href: 'https://t.me/coolpaylink',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-book-open-line',
      title: t('contact.docs.title'),
      content: t('contact.docs.description'),
      description: t('contact.docs.desc'),
      action: t('contact.docs.button'),
      href: '/docs/en/index.html',
      color: 'from-green-500 to-emerald-500'
    }
  ];

  return (
    <section id="contact" className="py-20 bg-slate-900 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>
        <div className="absolute inset-0 bg-[conic-gradient(from_0deg_at_50%_50%,rgba(6,182,212,0.1),transparent_120deg,rgba(139,92,246,0.1),transparent_240deg)]"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-gradient-to-r from-cyan-500/10 to-blue-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-48 h-48 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-full blur-3xl"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            {t('contact.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            {t('contact.subtitle')}
          </p>
        </div>

        {/* Contact Methods */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {contactMethods.map((method, index) => (
            <div key={index} className="group relative">
              <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 rounded-3xl border border-slate-700/50 backdrop-blur-sm p-8 hover:border-cyan-500/50 transition-all duration-300 hover:transform hover:scale-105 h-full">
                {/* Glow Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-blue-500/5 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

                {/* Icon */}
                <div className="relative mb-6">
                  <div className={`w-16 h-16 bg-gradient-to-r ${method.color} rounded-2xl flex items-center justify-center group-hover:shadow-lg group-hover:shadow-cyan-500/25 transition-all duration-300`}>
                    <i className={`${method.icon} text-2xl text-white`}></i>
                  </div>
                </div>

                {/* Content */}
                <div className="relative">
                  <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-cyan-400 transition-colors duration-300">
                    {method.title}
                  </h3>
                  
                  <div className="mb-4">
                    <p className="text-lg font-semibold text-cyan-400 mb-2">
                      {method.content}
                    </p>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      {method.description}
                    </p>
                  </div>

                  {method.href ? (
                    <a
                      href={method.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full inline-block px-6 py-3 bg-gradient-to-r from-slate-700 to-slate-600 border border-slate-600 text-white font-medium rounded-lg hover:border-cyan-500 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 transition-all duration-300 whitespace-nowrap text-center"
                    >
                      {method.action}
                    </a>
                  ) : (
                    <button className="w-full px-6 py-3 bg-gradient-to-r from-slate-700 to-slate-600 border border-slate-600 text-white font-medium rounded-lg hover:border-cyan-500 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 transition-all duration-300 whitespace-nowrap">
                      {method.action}
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Developer Resources removed per request */}
      </div>
    </section>
  );
};

export default Contact;